module.exports = function () {
  return "<div class=\"available-units-overlay\"></div>";
};